<a [routerLink]="draftUrl">
    <div class="draft-card-layout">
        <div class="draft-card-header">
            <liberro-avatar-photo-tagged [portfolioDetail]="{ portfolioType: draft.portfolioType}" size="44"></liberro-avatar-photo-tagged>
            <div class="name-wrapper">
                <div class="name">
                    {{ draft.name }}
                </div>
            </div>
            <liberro-badge
                variant="danger"
                [label]="('investments.draftCard.expiresIn' | translate) + (draft.autoExpiryTime | dayDiff)"
                [unbreakable]="true"
            ></liberro-badge>
        </div>
        <div class="detail-layout">
            <div class="label">
                {{ 'investments.draftCard.totalYearsToInvest' | translate }}
            </div>
            <div class="value">
                {{ draft.totalYearsToInvest | yearsTranslate }}
            </div>
            <div class="label">
                {{ 'investments.draftCard.regularDeposit' | translate }}
            </div>
            <div class="value">
                {{ draft.regularDeposit | price }}
            </div>
            <div class="label">
                {{ 'investments.draftCard.initialDeposit' | translate }}
            </div>
            <div class="value">
                {{ draft.initialDeposit | price }}
            </div>
            <div class="label">
                {{ 'investments.draftCard.weeksBetweenInvestments' | translate }}
            </div>
            <div class="value">
                {{ ('newInvestment.settings.frequency.' + (draft.weeksBetweenInvestments | fullFrequency)) | translate }}
            </div>

        </div>
    </div>
</a>